module.exports = "<div class=\"login forgotPassword\">\n    <header>\n        <img class=\"logo\" src=\"/img/logo-white.png\">\n        <p>Password reset instructions have been sent to you. <br> Don't forget to check your spam and junk mail <br> filters if they don't turn up.</p>\n    </header>\n    <footer>\n        <a class=\"returnToLogin\" href=\"/login\">Return to Login</a>\n    </footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/text-loader!./_src/ui/preLoginApp/password/passwordSent.html
// module id = 1053
// module chunks = 4